<template>
  <div></div>
</template>
<script>
export default {
  created() {
    let cacheId = this.getQueryString("cacheId");
    if (!!cacheId) {
      this.$http
        .post("/api/web/cas/getToken", { cacheId: cacheId })
        .then(res => {
          localStorage.getItem("ACCESS_TOKEN");
          this.$store.dispatch("login", res.data);
          this.getCurrentUser(res.data.moocLoginUrl);
        });
    }
  },
  methods: {
    // window  Url获取参数
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    },
    getCurrentUser(val) {
      if (
        !this.$store.getters.getRefreshToken &&
        !this.$store.getters.getAccessToken
      ) {
        this.$store.commit("UPDATE_LOGIN_STATUS", true);
        return;
      }
      this.$http
        .post("/api/web/user/getUserInfo")
        .then(data => {
          console.log(data);
          this.btnLoading = false;
          let { msg, code } = data;
          this.$store.dispatch("updateUserInfo", data.data);
          window.location.href = val;
        })
        .catch(({ code, msg }) => {});
    }
  }
};
</script>
